import { HTTPClient } from "../common/HTTPClient";

import { PaginationRequestParams } from "@/common/mixins/pagination";

export interface CreateShopRegisterTokenRequetParams {
  shopId: number;
}
export class ShopClient {
  constructor(private httpClient: HTTPClient) {}

  public async getShops(params: PaginationRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/shops",
      method: "GET",
      params
    });

    return data;
  }

  public async createShopRegisterToken(
    params: CreateShopRegisterTokenRequetParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/notification-shop-registers/token",
      method: "POST",
      data: params
    });

    return data;
  }
}
